export const PROFILE_KEYS = {
  first: "user_first_name",
  last: "user_last_name",
  email: "user_email",
}

export const PROFILE_CACHE_EVENT = "profile-cache-updated"

export const cacheProfileToLocal = (profile) => {
  const first = profile?.name?.toString().split(" ")[0]?.trim() || ""
  const last =
    profile?.last_name?.toString().trim() ||
    profile?.name?.toString().split(" ")[1]?.trim() ||
    ""
  const email = profile?.email?.toString().trim() || ""

  if (first) localStorage.setItem(PROFILE_KEYS.first, first)
  if (last) localStorage.setItem(PROFILE_KEYS.last, last)
  if (email) localStorage.setItem(PROFILE_KEYS.email, email)

  window.dispatchEvent(new Event(PROFILE_CACHE_EVENT))
}

export const clearCachedProfile = () => {
  Object.values(PROFILE_KEYS).forEach((key) => localStorage.removeItem(key))
  window.dispatchEvent(new Event(PROFILE_CACHE_EVENT))
}

export const readCachedProfile = () => {
  const first = (localStorage.getItem(PROFILE_KEYS.first) || "").trim()
  const last = (localStorage.getItem(PROFILE_KEYS.last) || "").trim()
  const email = (localStorage.getItem(PROFILE_KEYS.email) || "").trim()
  const displayName =
    [first, last].filter(Boolean).join(" ") || email || ""
  const initials =
    ((first[0] || "") + (last[0] || "")).toUpperCase() ||
    (email[0] || "U").toUpperCase()

  return { first, last, email, displayName, initials }
}

export const shouldShowDepositWarning = (profile) =>
  Boolean(profile) && profile.seen_deposit_warning !== true
